<div class="product-selection-container">
  @if (ruleGroupsArray) {
    @for (ruleGroup of ruleGroupsArray.controls; track ruleGroup; let i = $index) {
      <!-- OR separator between groups -->
      @if (i > 0) {
        <div class="or-separator">
          <span class="or-separator__text">OR</span>
        </div>
      }
      <pdq-collapsed [initialCollapsed]="false" [formGroup]="getRuleGroupFormGroup(i)">
        <pdq-collapsed-header>
          <div class="rule-group-header">
            <div class="rule-group-header__left">
              <span class="rule-group-header__title">Product Rule Group {{ i + 1 }}</span>
              <span class="rule-group-header__summary">{{ getRuleGroupSummary(i) }}</span>
            </div>
            <div class="rule-group-header__actions">
              <img
                src="assets/icons/copy-to-clipboard.svg"
                alt="Copy rule group"
                class="rule-group-header__action-icon"
                matTooltip="Copy rule group"
                matTooltipClass="pdq-mat-tooltip"
                (click)="duplicateRuleGroup(i); $event.stopPropagation()" />
              @if (ruleGroupsArray.length > 1) {
                <pdq-button
                  icon="trash"
                  size="small"
                  variant="ghost"
                  class="rule-group-header__delete-btn"
                  matTooltip="Delete rule group"
                  matTooltipClass="pdq-mat-tooltip"
                  (click)="removeRuleGroup(i); $event.stopPropagation()">
                </pdq-button>
              }
            </div>
          </div>
        </pdq-collapsed-header>
        <pdq-collapsed-content>
          <div class="rule-group-content">
            <!-- Products In Cart Section -->
            <div class="rule-section" formGroupName="productsInCart">
              <span class="rule-section__label">If Products In Cart Are:</span>
              <div class="toggle-group">
                <button
                  type="button"
                  (click)="setProductsInCartMode(i, 'any')"
                  [class.active]="getProductsInCartMode(i) === 'any'">
                  Any Products
                </button>
                <button
                  type="button"
                  (click)="setProductsInCartMode(i, 'smart')"
                  [class.active]="getProductsInCartMode(i) === 'smart'">
                  Smart Selection
                </button>
              </div>
              @if (getProductsInCartMode(i) === 'any') {
                <span class="rule-section__helper-text">Upsell will apply to all products in your store</span>
              }
              @if (getProductsInCartMode(i) === 'smart') {
                <pdq-rules-dynamic-form
                  [formGroup]="getRuleGroupFormGroup(i).get('productsInCart')"
                  formArrayFieldName="rules"
                  [rules]="productsInCartRules | addCurrencyOption: shopCurrencySymbol"
                  [entities]="productsInCartEntities"
                  [shopCurrencySymbol]="shopCurrencySymbol"
                  [versionWithOrOperator]="true">
                </pdq-rules-dynamic-form>
              }
            </div>

            <pdq-divider></pdq-divider>

            <!-- Upsell Products Section -->
            <div class="rule-section" formGroupName="upsellRecommendedProducts">
              <div class="rule-section__header">
                <span class="rule-section__label">Upsell Products Are</span>
                @if (getUpsellProductsMode(i) === 'smart') {
                  <button
                    type="button"
                    class="view-products-btn"
                    [class.loading]="isLoadingProducts(i)"
                    [disabled]="isLoadingProducts(i)"
                    matTooltip="Click this to preview the products that match your current smart rules."
                    matTooltipClass="pdq-mat-tooltip"
                    (click)="onViewProducts(i)">
                    @if (isLoadingProducts(i)) {
                      <span class="view-products-btn__spinner"></span>
                      Loading...
                    } @else {
                      View products
                    }
                  </button>
                }
              </div>
              <div class="toggle-group">
                <button
                  type="button"
                  (click)="setUpsellProductsMode(i, 'shopifyRecommendations')"
                  [class.active]="getUpsellProductsMode(i) === 'shopifyRecommendations'">
                  Automatic
                </button>
                <button
                  type="button"
                  (click)="setUpsellProductsMode(i, 'manual')"
                  [class.active]="getUpsellProductsMode(i) === 'manual'">
                  Manual
                </button>
                <button
                  type="button"
                  (click)="setUpsellProductsMode(i, 'smart')"
                  [class.active]="getUpsellProductsMode(i) === 'smart'">
                  Smart
                </button>
              </div>
              <span class="rule-section__helper-text">{{ getUpsellProductsHelperText(getUpsellProductsMode(i)) }}</span>
              @if (getUpsellProductsMode(i) === 'shopifyRecommendations') {
                <pdq-banner
                  variant="regular"
                  [closable]="false"
                  bannerTitle="Shopify Search & Discovery"
                  content="Products will be automatically recommended based on Shopify's Search & Discovery app. The recommendations are based on purchase history, related products, and customer behavior.">
                </pdq-banner>
                <pdq-banner variant="attention" [inline]="true" [closable]="false">
                  <p class="body-12-regular">
                    <span class="body-12-medium">Note:</span> Discounts aren’t available with Shopify recommendations.
                    Shopify picks these products at checkout, so we can’t verify which ones a discount would apply to.
                    Switch to Manual or Smart to add one.
                  </p>
                </pdq-banner>
              }

              @if (getUpsellProductsMode(i) === 'manual') {
                <div class="product-list-section">
                  <span class="product-list-section__label">Product List</span>
                  @if (getRuleGroupFormGroup(i).get('prioritizeRecommendedItemsBy')?.value === 'manual') {
                    <pdq-product-list
                      [products]="getUpsellProductsForDisplay(i)"
                      [showHeader]="true"
                      [showSearch]="true"
                      [showRemove]="true"
                      [showEdit]="true"
                      [showExternalLink]="true"
                      [showDragHandle]="true"
                      [currencySymbol]="shopCurrencySymbol"
                      searchPlaceholder="Search"
                      emptyMessage="No products selected"
                      (actionClick)="onAddProducts(i)"
                      (remove)="onRemoveProduct(i, $event.id)"
                      (edit)="onEditProduct(i, $event)"
                      (externalLink)="onExternalLink($event)"
                      (reorder)="onReorderProducts(i, $event)">
                    </pdq-product-list>
                  } @else {
                    <pdq-product-list
                      variant="summary"
                      [products]="getUpsellProductsForDisplay(i)"
                      [currencySymbol]="shopCurrencySymbol"
                      emptyMessage="No products selected"
                      (actionClick)="onAddProducts(i)">
                    </pdq-product-list>
                  }
                </div>
              }

              @if (getUpsellProductsMode(i) === 'smart') {
                <pdq-rules-dynamic-form
                  [formGroup]="getRuleGroupFormGroup(i).get('upsellRecommendedProducts')"
                  formArrayFieldName="rules"
                  [rules]="upsellProductsRules | addCurrencyOption: shopCurrencySymbol"
                  [entities]="upsellProductsEntities"
                  [shopCurrencySymbol]="shopCurrencySymbol"
                  [versionWithOrOperator]="true">
                </pdq-rules-dynamic-form>
                @if (getUpsellProducts(i).length > 0) {
                  <div class="product-list-section">
                    <span class="product-list-section__label"
                      >Matching Products ({{ getUpsellProducts(i).length }})</span
                    >
                    <pdq-product-list
                      [products]="getUpsellProductsForDisplay(i)"
                      [showSearch]="true"
                      [showRemove]="false"
                      [showEdit]="false"
                      [showExternalLink]="true"
                      [currencySymbol]="shopCurrencySymbol"
                      emptyMessage="No matching products"
                      (externalLink)="onExternalLink($event)">
                    </pdq-product-list>
                  </div>
                }
              }
            </div>

            <!-- Prioritize Section -->
            <div class="radio">
              <div class="radio__title">Prioritize Upsell Items By</div>
              <pdq-radio-group formControlName="prioritizeRecommendedItemsBy">
                @for (option of getPrioritizeOptionsForMode(i); track option.value) {
                  <pdq-radio-button
                    [value]="option.value"
                    [checked]="getRuleGroupFormGroup(i).get('prioritizeRecommendedItemsBy')?.value === option.value"
                    [text]="option.label"
                    [subText]="option.description">
                  </pdq-radio-button>
                }
              </pdq-radio-group>
              @if (getRuleGroupFormGroup(i).get('prioritizeRecommendedItemsBy')?.value === 'selling-plan') {
                <div class="selling-plan-config">
                  <pdq-input
                    [formControl]="getRuleGroupFormGroup(i).get('sellingPlanId')"
                    label="Selling Plan ID"
                    placeholder="Enter selling plan ID"
                    [invalid]="
                      getRuleGroupFormGroup(i).get('sellingPlanId')?.invalid &&
                      getRuleGroupFormGroup(i).get('sellingPlanId')?.touched
                    "
                    [invalidMsg]="
                      getRuleGroupFormGroup(i).get('sellingPlanId')?.errors?.required
                        ? 'Selling Plan ID is required'
                        : ''
                    ">
                  </pdq-input>
                  <div class="selling-plan-description">
                    <label class="selling-plan-description__label">Selling Plan Description</label>
                    <rich-textarea
                      [initialContent]="getRuleGroupFormGroup(i).get('sellingPlanDescription')?.value"
                      placeholder="Enter selling plan description..."
                      [enableLinkInsert]="true"
                      (contentChange)="getRuleGroupFormGroup(i).get('sellingPlanDescription')?.setValue($event)">
                    </rich-textarea>
                    @if (getRuleGroupFormGroup(i).get('sellingPlanDescription')?.errors?.missingPricePlaceholder) {
                      <span class="error-message">{{
                        getRuleGroupFormGroup(i).get('sellingPlanDescription')?.errors?.missingPricePlaceholder
                      }}</span>
                    }
                    <span class="selling-plan-description__helper"
                      >Use {{ '{' }}price{{ '}' }} to dynamically display the product price</span
                    >
                  </div>
                </div>
              }
            </div>

            <!-- Discounts Section -->
            @if (!isAutonomousDiscount) {
              <div class="discounts-section">
                @let isShopifyRecommendationsGroup = getUpsellProductsMode(i) === 'shopifyRecommendations';
                @let usesUpsellLevelDiscount = formGroup.get('applyDiscountToRecommendedProducts')?.value;
                @if (usesUpsellLevelDiscount) {
                  <pdq-banner variant="attention" [inline]="true" [closable]="false">
                    <p class="body-12-regular">
                      <span class="body-12-medium">Note:</span> This upsell uses the upsell level discount from the
                      Settings tab. Turn it off there to set discounts per product group.
                    </p>
                  </pdq-banner>
                } @else if (!isShopifyRecommendationsGroup) {
                  <pdq-checkbox
                    [formControl]="getRuleGroupFormGroup(i).get('applyDiscountToRecommendedProducts')"
                    label="Apply a discount to the recommended products"
                    secondaryLabel="Enabling this option will override Shopify's product discounts. If a product is eligible for multiple discounts, only the first discount applies."
                    labelSize="medium"
                    (onChange)="onApplyDiscountToggled(i, $event)"></pdq-checkbox>
                }
                @if (
                  !usesUpsellLevelDiscount &&
                  !isShopifyRecommendationsGroup &&
                  getRuleGroupFormGroup(i).get('applyDiscountToRecommendedProducts')?.value
                ) {
                  <div class="discounts-section__groups">
                    <div class="discounts-section__cards">
                      @for (
                        discountControl of getDiscountsFormArray(i)?.controls;
                        track discountControl;
                        let d = $index
                      ) {
                        @let discountGroup = discountControl | asFormGroup;
                        <div class="discount-card" [formGroup]="discountGroup">
                          <pdq-collapsed [initialCollapsed]="false">
                            <pdq-collapsed-header arrowStyle="chevron" padding="var(--padding-8)">
                              <div class="discount-card__header">
                                <span class="discount-card__title">Discount {{ d + 1 }}</span>
                                <div class="discount-card__actions">
                                  <pdq-button
                                    icon="duplicate"
                                    size="small"
                                    variant="ghost"
                                    iconColor="var(--on-surface-light)"
                                    aria-label="Duplicate discount"
                                    matTooltip="Duplicate discount"
                                    matTooltipClass="pdq-mat-tooltip"
                                    (click)="duplicateDiscountGroup(i, d); $event.stopPropagation()">
                                  </pdq-button>
                                  <pdq-button
                                    icon="trash"
                                    size="small"
                                    variant="ghost"
                                    iconColor="var(--error-default)"
                                    class="discount-card__delete-btn"
                                    matTooltip="Delete discount"
                                    matTooltipClass="pdq-mat-tooltip"
                                    (click)="removeDiscountGroup(i, d); $event.stopPropagation()">
                                  </pdq-button>
                                </div>
                              </div>
                            </pdq-collapsed-header>
                            <pdq-collapsed-content>
                              <div class="discount-card__body">
                                <div class="discount-card__fields">
                                  <div class="discount-card__field-row">
                                    <pdq-dropdown
                                      [formControl]="discountGroup.get('discountType')"
                                      title="Coupon type"
                                      [fullWidth]="true"
                                      [options]="discountTypeOptions"></pdq-dropdown>
                                    <pdq-input-arrows
                                      [formControl]="discountGroup.get('discountValue')"
                                      label="Coupon Value"
                                      widthSize="fullwidth"
                                      precision="2"
                                      [min]="0"
                                      [max]="
                                        discountGroup.get('discountType').value === DiscountType.Percentage
                                          ? 100
                                          : undefined
                                      "
                                      [symbol]="
                                        discountGroup.get('discountType').value === DiscountType.Percentage
                                          ? '%'
                                          : defaultCurrencySymbol
                                      "></pdq-input-arrows>
                                  </div>
                                  <div class="discount-card__field-row">
                                    <pdq-input
                                      [formControl]="discountGroup.get('labelText')"
                                      label="Append a label to the product name"
                                      placeholder="ie.: (25% Off)"></pdq-input>
                                    <pdq-dropdown
                                      [formControl]="discountGroup.get('labelColor')"
                                      title="Label color"
                                      [fullWidth]="true"
                                      [options]="labelColorOptions"></pdq-dropdown>
                                  </div>
                                </div>
                                <div class="discount-card__selection">
                                  <div class="discount-card__apply-to">
                                    <span class="discount-card__apply-to-label">Product selection:</span>
                                    <pdq-dropdown
                                      class="discount-card__apply-to-dropdown"
                                      [formControl]="discountGroup.get('applyTo.mode')"
                                      [fullWidth]="true"
                                      [options]="discountApplyToModeOptions"></pdq-dropdown>
                                  </div>
                                  @if (getDiscountApplyToMode(i, d) === 'manual') {
                                    <div class="discount-card__product-list">
                                      <span class="discount-card__product-list-label">Product list</span>
                                      <div class="discount-card__product-list-summary">
                                        <div class="discount-card__product-list-row">
                                          <span class="discount-card__product-list-count"
                                            >{{ getDiscountProducts(i, d).length }} Products added</span
                                          >
                                          <pdq-link
                                            label="Edit"
                                            [clickable]="true"
                                            (click)="openDiscountProductsModal(i, d)"></pdq-link>
                                        </div>
                                        <span class="discount-card__product-list-names">{{
                                          getDiscountProductsSummary(i, d)
                                        }}</span>
                                      </div>
                                    </div>
                                  }
                                  @if (getDiscountApplyToMode(i, d) === 'smart') {
                                    <pdq-rules-dynamic-form
                                      [formGroup]="discountGroup.get('applyTo')"
                                      formArrayFieldName="rules"
                                      [rules]="upsellProductsRules | addCurrencyOption: shopCurrencySymbol"
                                      [entities]="upsellProductsEntities"
                                      [shopCurrencySymbol]="shopCurrencySymbol"
                                      [versionWithOrOperator]="true"
                                      [showEmptyRowByDefault]="true">
                                    </pdq-rules-dynamic-form>
                                  }
                                </div>
                              </div>
                            </pdq-collapsed-content>
                          </pdq-collapsed>
                        </div>
                      }
                    </div>
                    <pdq-button
                      class="add-discount-group-btn"
                      plain="true"
                      icon="Plus"
                      size="small"
                      label="Add Discount Group"
                      variant="ghost-light"
                      (onClick)="addDiscountGroup(i)">
                    </pdq-button>
                  </div>
                }
              </div>
            }

            <!-- Product Restrictions Section -->
            <div class="restrictions-section">
              <div class="radio__title">Product Restrictions</div>
              <div class="restrictions-card">
                <div class="restriction-item">
                  <pdq-checkbox
                    formControlName="matchProductVariants"
                    label="Match Product Variants"
                    secondaryLabel="Automatically pre-select the variant that best matches items in the customer's cart."
                    labelSize="small">
                  </pdq-checkbox>
                </div>
                <div class="restriction-item">
                  <pdq-checkbox
                    formControlName="inStockProductsOnly"
                    label="In-stock products only"
                    secondaryLabel="Only show upsell products that have available inventory."
                    labelSize="small">
                  </pdq-checkbox>
                </div>
                <div class="restriction-item">
                  <pdq-checkbox
                    formControlName="matchFulfillmentCenterToCartItems"
                    label="Match fulfillment center"
                    secondaryLabel="Only show products that can be fulfilled from the same location as the cart items."
                    labelSize="small">
                  </pdq-checkbox>
                </div>
                <div class="restriction-item">
                  <pdq-checkbox
                    formControlName="includeDigitalItems"
                    label="Include digital items"
                    secondaryLabel="Allow digital products (non-shippable items) to appear as upsells."
                    labelSize="small">
                  </pdq-checkbox>
                </div>
                <div class="restriction-item">
                  <pdq-checkbox
                    [checked]="getHideProductsValue(i) !== 'none'"
                    (onChange)="toggleHideProducts(i, $event)"
                    label="Hide products already in cart"
                    secondaryLabel="Don't show upsell products that the customer has already added to their cart."
                    labelSize="small">
                  </pdq-checkbox>
                  @if (getHideProductsValue(i) !== 'none') {
                    <div class="restriction-nested">
                      <div class="radio__title">Detection Level</div>
                      <pdq-radio-group
                        [ngModel]="getHideProductsValue(i)"
                        (ngModelChange)="setHideProductsValue(i, $event)"
                        [ngModelOptions]="{ standalone: true }">
                        @for (option of hideProductsOptions; track option.value) {
                          <pdq-radio-button
                            [value]="option.value"
                            [checked]="getHideProductsValue(i) === option.value"
                            [text]="option.label"
                            [subText]="option.description">
                          </pdq-radio-button>
                        }
                      </pdq-radio-group>
                    </div>
                  }
                </div>
              </div>
            </div>

            <pdq-divider></pdq-divider>
            <!-- Settings Section -->
            <div class="settings-section">
              <div class="radio__title">Settings</div>
              <div class="settings-row">
                <div class="settings-field">
                  <label class="settings-field__label">Max number of items to display</label>
                  <pdq-input formControlName="maxItemsToDisplay" type="number"></pdq-input>
                </div>
                <div class="settings-field">
                  <label class="settings-field__label">If no items available to display</label>
                  <pdq-dropdown
                    formControlName="NoItemsToDisplay"
                    [options]="ifNoItemsOptions"
                    optionLabel="label"
                    optionValue="value">
                  </pdq-dropdown>
                </div>
              </div>
            </div>
          </div>
        </pdq-collapsed-content>
      </pdq-collapsed>
    }
  }

  <button type="button" class="add-rule-group-btn" (click)="addRuleGroup()">+ Add Rule Group</button>

  <div class="section appearance-section">
    <pdq-heading element="h5">Appearance</pdq-heading>
    <div class="controls-wrapper">
      <!-- Product Display Type - Tab Menu -->
      <div class="appearance-group">
        <p class="appearance-group__title">Product display type</p>
        <div class="tab-menu">
          @for (option of displayTypeOptions; track option.value) {
            <button
              type="button"
              class="tab-menu__item"
              [class.tab-menu__item--active]="formGroup.get('style.displayType')?.value === option.value"
              (click)="setDisplayType(option.value)">
              @if (option.icon) {
                <pdq-icon [icon]="option.icon" size="small"></pdq-icon>
              }
              <span>{{ option.text }}</span>
            </button>
          }
        </div>
        @if (formGroup.get('style.displayType')?.value === 'row') {
          <div class="number-of-rows-field">
            <pdq-input-arrows
              [formControl]="formGroup.get('style.numberOfRowsInRowDisplayType')"
              label="Number of rows"
              [min]="1"
              [max]="5"
              widthSize="auto"
              [precision]="0"
              [step]="1"></pdq-input-arrows>
          </div>
        }
        @if (formGroup.get('style.displayType')?.value === 'cards') {
          <div class="appearance-group appearance-group--navigation-style">
            <p class="appearance-group__title">Navigation Style</p>
            <pdq-radio-group [formControl]="formGroup.get('style.carouselNavigationStyle')">
              @for (option of carouselNavigationStyleOptions; track option.value) {
                <pdq-radio-button
                  [value]="option.value"
                  [checked]="formGroup.get('style.carouselNavigationStyle')?.value === option.value"
                  [text]="option.text"
                  [subText]="option.description">
                </pdq-radio-button>
              }
            </pdq-radio-group>
          </div>
        }
      </div>

      @if (isProductDisplayEnabled) {
        <pdq-divider></pdq-divider>

        <div class="appearance-group appearance-group--variant-selector">
          <p class="appearance-group__title">Variant Selector</p>
          <pdq-radio-group [formControl]="formGroup.get('settings.variantSelector')">
            @for (option of variantSelectorOptions; track option.value) {
              <pdq-radio-button
                [value]="option.value"
                [checked]="formGroup.get('settings.variantSelector')?.value === option.value"
                [text]="option.label"
                [subText]="option.helpText">
              </pdq-radio-button>
            }
          </pdq-radio-group>
        </div>

        <!-- Button Text Fields -->
        <div class="input-group">
          <pdq-input
            [formControl]="formGroup.get('settings.textAddToOrder')"
            label="Button Display Text"
            placeholder="Add to order"
            [invalid]="formGroup.get('settings.textAddToOrder').invalid"
            [invalidMsg]="formGroup.get('settings.textAddToOrder').errors?.required ? 'required' : ''"></pdq-input>
          @if (formGroup.get('settings.variantSelector')?.value === 'outside') {
            <pdq-input
              [formControl]="formGroup.get('settings.variantButtonText')"
              label="Button Text For Products With Variants"
              placeholder="Select an option"></pdq-input>
          }
        </div>

        <!-- Button Appearance -->
        <div class="input-group" [formGroup]="formGroup">
          <div formGroupName="style">
            <pdq-dropdown
              formControlName="buttonAppearance"
              title="Button Appearance"
              [defaultOption]="
                formGroup.get('style.buttonAppearance').value | primitiveDropdownOptionPipe: appearanceToDisplayText
              "
              [options]="Appearances | primitiveDropdownOptionsPipe: appearanceToDisplayText"></pdq-dropdown>
          </div>
        </div>
        <pdq-divider></pdq-divider>

        <div
          class="droplist"
          [cdkDropListData]="additionalDisplayTextsFormArray?.value"
          cdkDropList
          (cdkDropListDropped)="drop($event)">
          @for (additionalDisplayText of additionalDisplayTextsFormArray?.controls; track additionalDisplayText) {
            @let displayTextGroup = additionalDisplayText | asFormGroup;
            <div [cdkDragData]="additionalDisplayText.value" cdkDrag>
              <form [formGroup]="displayTextGroup">
                <div class="drag-content-wrapper">
                  <pdq-collapsed [initialCollapsed]="!displayTextGroup.get('display').value">
                    <pdq-collapsed-header>
                      <div class="additional-display-text-content__title">
                        <h4>
                          Display
                          {{ displayTextGroup.get('type')?.value | toAdditionalDisplayLabelText }}
                        </h4>
                        <div class="additional-display-text-content__title-actions">
                          <div cdkDragHandle class="drag-wrapper">
                            @for (rectangle of dragHandleRectangles; track $index) {
                              <div class="drag-rectangle"></div>
                            }
                          </div>
                          <pdq-collapsed-trigger>
                            <pdq-slide-toggle
                              class="slide-toggle"
                              [formControl]="displayTextGroup.get('display')"></pdq-slide-toggle>
                          </pdq-collapsed-trigger>
                        </div>
                      </div>
                    </pdq-collapsed-header>
                    <pdq-collapsed-content>
                      <div class="additional-display-text-content__body">
                        <pdq-input
                          [formControl]="displayTextGroup.get('text')"
                          [label]="
                            (displayTextGroup.get('type')?.value | toAdditionalDisplayLabelText | titlecase) +
                            ' display text'
                          "
                          type="text"
                          [invalid]="displayTextGroup.get('text').invalid"
                          [invalidMsg]="displayTextGroup.get('text').errors?.additionalPattern"></pdq-input>
                        <span class="additional-display-text-content__helper"
                          >Use the tag {{ '{' + displayTextGroup.get('type')?.value + '}' }} to dynamically display the
                          {{ displayTextGroup.get('type')?.value | toAdditionalDisplayLabelText }}</span
                        >
                      </div>
                    </pdq-collapsed-content>
                  </pdq-collapsed>
                </div>
              </form>
            </div>
          }
        </div>

        <div class="collapsible-section">
          <pdq-collapsed [initialCollapsed]="!formGroup.get('settings.showDiscountBadgeOrText')?.value">
            <pdq-collapsed-header>
              <div class="collapsible-header collapsible-header--with-toggle">
                <span class="collapsible-title">Show Discount badge</span>
                <pdq-collapsed-trigger>
                  <pdq-slide-toggle
                    [formControl]="formGroup.get('settings.showDiscountBadgeOrText')"></pdq-slide-toggle>
                </pdq-collapsed-trigger>
              </div>
            </pdq-collapsed-header>
            <pdq-collapsed-content>
              <div class="collapsible-body" [formGroup]="formGroup">
                <div formGroupName="settings">
                  <pdq-radio-group formControlName="discountBadgeDisplayType">
                    @for (option of badgeDisplayTypeOptions; track option.value) {
                      <pdq-radio-button
                        [value]="option.value"
                        [checked]="formGroup.get('settings.discountBadgeDisplayType')?.value === option.value"
                        [text]="option.label"
                        [subText]="option.helpText">
                      </pdq-radio-button>
                    }
                  </pdq-radio-group>
                  @if (formGroup.get('settings.discountBadgeDisplayType')?.value === 'badge') {
                    <div class="flex-row flex-row--three">
                      <pdq-input-color
                        label="Background Color"
                        [control]="formGroup.get('settings.discountBadgeBackgroundColor')"
                        [formControl]="formGroup.get('settings.discountBadgeBackgroundColor')"></pdq-input-color>
                      <pdq-input-color
                        label="Text Color"
                        [control]="formGroup.get('settings.discountBadgeTextColor')"
                        [formControl]="formGroup.get('settings.discountBadgeTextColor')"></pdq-input-color>
                      <pdq-dropdown
                        [formControl]="formGroup.get('settings.discountBadgeCornerRadius')"
                        title="Corner Radius"
                        [options]="cornerRadiusOptions"></pdq-dropdown>
                    </div>
                  }
                  @if (formGroup.get('settings.discountBadgeDisplayType')?.value === 'text') {
                    @if (isAutonomousDiscount) {
                      <pdq-banner variant="attention" [inline]="true" [closable]="false">
                        <p class="body-12-regular">
                          <span class="body-12-medium">Note:</span> Autonomous Checkout chooses this discount, so its
                          label is set in the Discounts card on the Settings tab.
                        </p>
                      </pdq-banner>
                    } @else {
                      <div class="flex-row">
                        <pdq-input
                          [formControl]="formGroup.get('discountConfiguration.labelText')"
                          label="Append a label to the product name"
                          placeholder="ie.: (25% Off)"
                          [invalid]="formGroup.get('discountConfiguration.labelText').invalid"
                          [invalidMsg]="
                            formGroup.get('discountConfiguration.labelText').errors?.required ? 'required' : ''
                          "></pdq-input>
                        <pdq-dropdown
                          [formControl]="formGroup.get('discountConfiguration.labelColor')"
                          title="Label color"
                          [options]="labelColorOptions"></pdq-dropdown>
                      </div>
                    }
                  }
                </div>
              </div>
            </pdq-collapsed-content>
          </pdq-collapsed>
        </div>

        <div class="collapsible-section">
          <pdq-collapsed [initialCollapsed]="!formGroup.get('settings.productReviews.enabled')?.value">
            <pdq-collapsed-header>
              <div class="collapsible-header collapsible-header--with-toggle">
                <span class="collapsible-title">Show product reviews</span>
                <pdq-collapsed-trigger>
                  <pdq-slide-toggle [formControl]="formGroup.get('settings.productReviews.enabled')"></pdq-slide-toggle>
                </pdq-collapsed-trigger>
              </div>
            </pdq-collapsed-header>
            <pdq-collapsed-content>
              <div class="collapsible-body">
                <checkout-upsell-product-reviews
                  [formGroup]="productReviewsFormGroup"
                  [shopCurrencySymbol]="shopCurrencySymbol"
                  (addExcludedProducts)="onAddExcludedReviewProducts()"
                  (removeExcludedProduct)="onRemoveExcludedReviewProduct($event)">
                </checkout-upsell-product-reviews>
              </div>
            </pdq-collapsed-content>
          </pdq-collapsed>
        </div>

        <div class="collapsible-section">
          <pdq-collapsed [initialCollapsed]="true">
            <pdq-collapsed-header>
              <div class="collapsible-header">
                <span class="collapsible-title">Advanced styling</span>
              </div>
            </pdq-collapsed-header>
            <pdq-collapsed-content>
              <div class="collapsible-body" [formGroup]="formGroup">
                <div formGroupName="style" class="styling-subsections-container">
                  <!-- Main Background -->
                  <div class="styling-subsection">
                    <p class="styling-subsection__title">Main Background</p>
                    <div class="flex-row flex-row--four">
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.mainBackgroundStyling.border')"
                        title="Border"
                        [options]="borderOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.mainBackgroundStyling.borderWidth')"
                        title="Border Width"
                        [options]="borderWidthOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.mainBackgroundStyling.cornerRadius')"
                        title="Corner Radius"
                        [options]="mainBackgroundCornerRadiusOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.mainBackgroundStyling.padding')"
                        title="Padding"
                        [options]="paddingOptions"></pdq-dropdown>
                    </div>
                  </div>

                  <!-- Card Background -->
                  <div class="styling-subsection">
                    <p class="styling-subsection__title">Card Background</p>
                    <div class="flex-row flex-row--four">
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.cardBackgroundStyling.border')"
                        title="Border"
                        [options]="borderOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.cardBackgroundStyling.borderWidth')"
                        title="Border Width"
                        [options]="borderWidthOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.cardBackgroundStyling.cornerRadius')"
                        title="Corner Radius"
                        [options]="cornerRadiusOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.cardBackgroundStyling.padding')"
                        title="Padding"
                        [options]="paddingOptions"></pdq-dropdown>
                    </div>
                  </div>

                  <!-- Image -->
                  <div class="styling-subsection">
                    <p class="styling-subsection__title">Image</p>
                    <div class="flex-row flex-row--four">
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.imageStyling.border')"
                        title="Border"
                        [options]="borderOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.imageStyling.borderWidth')"
                        title="Border Width"
                        [options]="borderWidthOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.imageStyling.cornerRadius')"
                        title="Corner Radius"
                        [options]="cornerRadiusOptions"></pdq-dropdown>
                      <pdq-dropdown
                        [formControl]="formGroup.get('style.imageStyling.padding')"
                        title="Padding"
                        [options]="paddingOptions"></pdq-dropdown>
                    </div>
                  </div>

                  <!-- Image Fit -->
                  <div class="styling-subsection">
                    <p class="styling-subsection__title">Image Fit</p>
                    <pdq-radio-group [formControl]="formGroup.get('style.imageStyling.imageFit')">
                      @for (option of imageFitOptions; track option.value) {
                        <pdq-radio-button
                          [value]="option.value"
                          [checked]="formGroup.get('style.imageStyling.imageFit')?.value === option.value"
                          [text]="option.label"
                          [subText]="option.helpText">
                        </pdq-radio-button>
                      }
                    </pdq-radio-group>
                  </div>
                </div>
              </div>
            </pdq-collapsed-content>
          </pdq-collapsed>
        </div>
      }
    </div>
  </div>
</div>
